export default "__VITE_ASSET__83xZYV9$__"